import { getToken } from "../services/tokenService";

export const apiClient = async (url, options = {}) => {
  const token = getToken();

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };

  const res = await fetch(url, {
    ...options,
    headers,
  });

  return res.json();
};